export default "__VITE_ASSET__ByZQbb1r__"